import React from "react";
import svg7 from "../../../../assets/svg/svg7.svg";
import svg33 from "../../../../assets/svg/svg33.svg";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatPipelineName, formatText } from "../../../../utils";

function Header() {
  const urlSingle = "api/v2/main_projects/get";
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.fetch);
  const { loading, activeObjPlannedProject, dataProjSingle } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      activeObjPlannedProject: state.obj.activeObj["plannedProject"],
      dataProjSingle: state.fetch.data[urlSingle] || [],
    })
  );

  return (
    <>
      <div className="">
        <div className="text-[#0092CC] font-interSans font-[500] text-[.75rem]">
          {dataProjSingle?.[0]?.projectNumber}
        </div>
        <div className="form-add-h !text-[#050505] mt-[.63rem]">
          {dataProjSingle?.[0]?.projectName}
        </div>
        <div className="proj_desc mt-[.62rem]">
          {dataProjSingle?.[0]?.projectRemarks}
        </div>
        {dataProjSingle?.[0]?.projectApprovedBy && (
          <div className="proj_desc mt-[.62rem] flex items-center gap-x-[.62rem]">
            Approved By: {dataProjSingle?.[0]?.projectApprovedBy} on{" "}
            {dataProjSingle?.[0]?.projectDateApproved}
          </div>
        )}

        <div className="mt-[1.25rem] flex lg:flex-row flex-col gap-y-2 lg:items-center gap-x-[.62rem] w-full">
          <div className="flex items-center gap-x-1">
            <img src={svg7} alt="svg7" />
            <span className="forgot-text">
              {dataProjSingle?.[0]?.projectCountyName}
            </span>
          </div>

          <div className="flex items-center gap-x-1 ">
            <img src={svg33} alt="svg33" />
            <span className="forgot-text">NIA</span>
          </div>

          <div className="flex  items-center justify-center gap-[.62rem] w-auto bg-[#E5E7E9] rounded-[.5rem] px-[.5rem] py-[.25rem]">
            {formatPipelineName(dataProjSingle?.[0]?.projectStatus)}
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
